import {fancyClient, extractData} from '@freckle/educator-entities/ts/openapi-clients'

export const DEFAULT_COURSE_QUERY_KEY = 'fetchDefaultCourseIdForTeacher'

export const fetchDefaultCourseIdForTeacher = (): Promise<number> =>
  fancyClient.GET('/3/teachers/me/default-course-id').then(extractData)
